/**
 * @module
 * @exports init
 * @description The geolocation functionality for the address field.
 *
 */

import { delegate } from '@gravityforms/utils';
import gform from 'gform';
import jQuery from 'jquery';

const GEOLOCATION_SUGGESTION_SETTING = 'ggeolocationEnableGeolocationSuggestions';

/**
 * @function filterFieldSettings
 * @description Filter field settings to add geolocation suggestions setting.
 *
 * @param {Array}  settings Array of settings classes to show for a given field.
 * @param {object} field    The field to filter settings.
 *
 * @return {Array} The settings.
 */
const filterFieldSettings = ( settings, field ) => {
	// Return early if not address field.
	if ( 'address' !== field.type ) {
		return settings;
	}

	// Return early if geolocation setting is already in the array.
	if ( -1 !== settings.indexOf( '.geolocation_suggestions_setting' ) ) {
		return settings;
	}

	settings.push( '.geolocation_suggestions_setting' );

	return settings;
};

/**
 * @function loadFieldSettings
 * @description Loads the geolocation settings for the address field.
 *
 * @param {object} event The event object.
 * @param {object} field The field to load settings.
 * @param {object} form  The form object.
 *
 * @return {void}
 */
const loadFieldSettings = ( event, field, form ) => { /* eslint-disable-line no-unused-vars */
	// Return early if not address field.
	if ( 'address' !== field.type ) {
		return;
	}

	if ( 'undefined' === typeof field[ GEOLOCATION_SUGGESTION_SETTING ] ) {
		field[ GEOLOCATION_SUGGESTION_SETTING ] = false;
	}

	jQuery( '#ggeolocation-enable-geolocation-suggestions' )
		.prop( 'checked', field[ GEOLOCATION_SUGGESTION_SETTING ] );
};

/**
 * @function handleGeolocationSuggestionsChange
 * @description Handles the change event for the geolocation suggestions setting.
 *
 * @param {object} event The event object.
 *
 * @return {void}
 */
const handleGeolocationSuggestionsChange = ( event ) => {
	// SetFieldProperty is not a function, something is wrong, return early.
	if ( 'function' !== typeof window.SetFieldProperty ) {
		return;
	}

	const { target } = event;
	window.SetFieldProperty( GEOLOCATION_SUGGESTION_SETTING, target.checked );
};

/**
 * @function addHooks
 * @description Add hooks and handlers.
 *
 */
const addHooks = () => {
	gform.addFilter( 'gform_editor_field_settings', filterFieldSettings );
};

/**
 * @function bindEvents
 * @description Binds events for this module.
 *
 */
const bindEvents = () => {
	jQuery( document ).on( 'gform_load_field_settings', loadFieldSettings );
	delegate(
		'#ggeolocation-enable-geolocation-suggestions',
		'input',
		'change',
		handleGeolocationSuggestionsChange,
		false,
	);
};

/**
 * @function init
 * @description Initialize this module functionality.
 *
 */
const init = () => {
	bindEvents();
	addHooks();
};

export default init;
